export const BANNER_DATA = {
  text: "Kelp Grand Miles are now Kernel Points. 1 Kelp Grand Mile  = 1 Kernel Point",
  cta_text: "Learn more →",
  cta_link: "",
  pages: ["/dashboard"],
};

export const BANNER_IMAGES = [
  "/assets/banner1.png",
  "/assets/banner2.png",
  "/assets/banner3.png",
  // "/assets/banner4.png",
  // "/assets/banner-blast.png",
];
